import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types'
Dimmer.propTypes={active:PropTypes.bool.isRequired,};
import logo from '../imagenes/opensii.png'
export function Dimmer({active}) {

    const btnClose = useRef();
    let op = require('../modulos/datos');


    return (

        
        <div
            style={{
                /*  backgroundColor: 'rgba(0, 0, 0, 0.479)', */
                position: 'fixed',  // Cambiado a 'fixed' para estar fijo en la ventana
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                justifyContent: 'center',
                alignItems: 'center',
                visibility: active ?  'visible' : 'collapse' ,
                zIndex: 9999,  // Alto valor para asegurar que esté por encima de todo
                background: '#0575E6',  /* fallback for old browsers */
                background: '-webkit-linear-gradient(to left, rgba(2, 27, 121, 0.6), rgba(5, 117, 230, 0.69))',  /* Chrome 10-25, Safari 5.1-6 */
                background: 'linear-gradient(to left, rgba(2, 27, 121, 0.6), rgba(5, 117, 230, 0.69))', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

            }}
            className='d-flex justify-content-center mx-auto p-0 mx-0'
        >
            <div className="spinner-3">
            </div>
            <img src={logo} alt="Girl in a jacket" style={{position:'absolute', maxHeight:60, maxWidth:130}} width="500" height="600"/> 

        </div>
    );
}

